import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Grid,
  Stack,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import BlockIcon from '@mui/icons-material/Block';
import CloseIcon from '@mui/icons-material/Close';

const MessageDetailsControls = ({
  closeFunc,
  selectedTab,
}) => {
  return (
    <Box
      py={1.25}
      px={2.5}
      borderBottom="1px solid var(--color_ddd)"
    >
      <Grid
        container
        direction="row"
        justifyContent="space-between"
      >
        <Stack
          direction="row"
          spacing={2}
        >
          { selectedTab !== 'notifications' && (
            <Grid item>
              <DeleteIcon
                onClick={() => {}}
                sx={{ cursor: 'pointer' }}
              />
            </Grid>
          )}

          { selectedTab === 'inbox' && (
            <Grid item>
              <BlockIcon
                onClick={() => {}}
                sx={{ cursor: 'pointer' }}
              />
            </Grid>
          )}
        </Stack>

        <Grid item>
          <CloseIcon onClick={closeFunc} sx={{ cursor: 'pointer' }} />
        </Grid>
      </Grid>
    </Box>
  );
};

MessageDetailsControls.propTypes = {
  closeFunc: PropTypes.func.isRequired,
  selectedTab: PropTypes.string.isRequired,
};

export default MessageDetailsControls;
